import { ShieldAlert } from "lucide-react";

export const BillingAccessBanner = () => {
  return (
    <div className="container mx-auto px-4 pt-6">
      <div className="relative overflow-hidden rounded-xl border border-warning-border bg-gradient-to-r from-warning-subtle/80 via-white to-warning-subtle/80 px-4 py-3 shadow-sm">
        <div className="relative flex items-start gap-3">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-warning-subtle-strong text-warning-text">
            <ShieldAlert className="h-4 w-4" />
          </div>
          <div className="flex flex-col gap-0.5 pt-0.5">
            <h3 className="text-sm font-semibold text-warning-text">Billing access restricted</h3>
            <p className="text-xs leading-snug text-warning-text/80">
              You can view subscription plans, but you don&apos;t have permission to manage billing.
              Please contact a firm administrator to upgrade your plan, update payment methods, or
              make other billing changes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
